import { FieldTranslation, FlooriIcons, HashMap, Languages } from '@floori-web-components';
import { FlooriFontFamily, FlooriThemes } from '../styles';
import { FlooriPages, Layouts } from './layouts';
import { ProductCategory } from './product-category';
import { ValidationRules } from './validation-rules';

export enum CompanyType {
    default,
    carpet,
    epoxy,
}

export interface Integration {
    type: IntegrationType;
}

export enum IntegrationType {
    floori = 'floori',
    woocommerce = 'woocommerce',
}

export interface CompanyConfigBasicDto {
    readonly id: string;
    readonly cacheUploadedRooms: boolean;
    readonly companyType: CompanyType;
    readonly integration?: Integration;
    readonly defaultLanguage: Languages;
    readonly defaultProductId?: string;
    readonly header?: Header;
    readonly hideHeader?: boolean;
    readonly languages: Languages[];
    readonly logo?: string;
    readonly consultantAvatar?: string;
    readonly supportedProductTypes?: ProductCategory[];
    readonly themeCssVars?: HashMap<string>;
    readonly themeSettings?: FlooriThemeSettings;
    readonly utmSource?: string;
    readonly isGTMEnabled?: boolean;
    readonly showUploadSection?: boolean;
}

export interface BoostRenderConfig {
    readonly isEnabled: boolean;
    readonly limit: string;
    readonly used: Record<string, number>;
    readonly onlyForCustomScenes: boolean;
    readonly onlyForLoggedUsers: boolean;
}

import { ConsultantConfig } from './consultant-config';

export interface CompanyConfigDetailsDto {
    readonly company: string;
    readonly disclaimer?: DisclaimerData;
    readonly consultantConfig?: ConsultantConfig;
    readonly filterProductsByRoomCategory: boolean;
    readonly filtersEnabled: boolean;
    readonly flooriIoLinkEnable?: boolean;
    readonly showProductPrice?: boolean;
    readonly supportsAR?: boolean;
    readonly supportsGlossiness?: boolean;
    readonly supportsMovePattern?: boolean;
    readonly supportsGroutVisibility?: boolean;
    readonly supportsQuestions?: boolean;
    readonly supportsBaseColorsInCatalogsVisibility?: boolean;
    readonly supportsMultipleChipSelect?: boolean;
    readonly supportsGallery?: boolean;
    readonly selectedProductFields?: string[];
    readonly watermark?: string;
    readonly validationRules: ValidationRules;
    readonly vendorUrl?: string;
    readonly isPreviewModeEnabled?: boolean;
    readonly boostRender?: BoostRenderConfig;
}

export interface CompanyConfig extends CompanyConfigBasicDto, CompanyConfigDetailsDto {
    readonly epoxyView?: boolean;
    readonly dynamicFeatures?: DynamicFeatures;
    readonly statusCode?: number;
    readonly vendorUrl?: string;
}

export interface DisclaimerData {
    id: string;
    title: string;
    text: string;
}

export interface FlooriThemeSettings {
    readonly theme: FlooriThemes;
    readonly fontFamily: FlooriFontFamily;
    readonly iconFamily: FlooriIcons;
    readonly hasCustomHtml?: boolean;
}

export interface ConfigState {
    readonly company?: CompanyConfig;
    readonly layouts?: Record<FlooriPages, Layouts | null>;
    readonly logoUrl?: string;
    readonly logoSplash?: string;
    readonly theme?: FlooriThemeSettings;
    readonly langs?: Languages[];
    readonly currentLang?: Languages;
    readonly themeCssVars?: HashMap<string>;
    readonly vendorUrl?: string;
    readonly epoxyView?: boolean;
    readonly validationRules?: ValidationRules;
}

export interface DynamicFeatures {
    readonly roomsMessage?: string;
    readonly roomMessage?: string;
    readonly roomProductMessage?: string;
    readonly translationScope?: string;
    readonly hideProductDetails?: boolean;
    readonly roomsCtaButton?: RoomsCtaButton;
    readonly marketingHeader1?: string;
    readonly marketingHeader2?: string;
    readonly marketingSubHeader?: string;
}

export interface RoomsCtaButton {
    visible: boolean;
    url: string;
    label: FieldTranslation;
    icon?: string;
}

export interface Header {
    id: string;
    customHeaderEnabled: boolean;
    titleBlack?: string;
    titleColored?: string;
    subTitle?: string;
    customImagesEnabled: boolean;
    imageDesktopUrl?: string;
    imageMobileUrl?: string;
}
